import { Component,OnInit,OnDestroy,AfterViewInit } from '@angular/core';
import { takeWhile,map } from "rxjs/operators";
import { Router,ActivatedRoute,ParamMap,NavigationExtras } from "@angular/router";

import {
    FvmsCommonService
} from "src/app/shared/service";

import {
    DtgListType
} from "src/app/shared/vo";

@Component({
    templateUrl: './dtg.report.car.trip.detail.component.html'
    ,styleUrls: ["./dtg.report.car.trip.detail.component.scss"]
})
export class DtgReportCarTripDetailComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    subtitle: string;
    companyInfo:any;
    DtgListType = DtgListType;
    dtgUnitId:string;
    fvmsTripCnt:string;
    
    constructor(
        private fvmsCommonService: FvmsCommonService
        ,private activatedRoute: ActivatedRoute
        ,private router: Router
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.dtgUnitId = this.activatedRoute.snapshot.params.dtgUnitId;
        this.fvmsTripCnt = this.activatedRoute.snapshot.params.fvmsTripCnt;
    }

    ngOnInit() {
        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                if(companyInfo && this.companyInfo){
                    if(this.companyInfo.dtgEid !== companyInfo.dtgEid){
                        //회사가 바뀌면 차량 목록이 다르므로 메인 페이지로 이동해야 함
                        let tmpParam = {
                            runtime:new Date().getTime()
                        };
                        let navigationExtras:NavigationExtras = {
                            queryParams:tmpParam
                        };
                        this.router.navigate(["/dtg/report/car/all"],navigationExtras);
                    }
                }else{
                    this.companyInfo = companyInfo;
                }
            });
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {}
}
